import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Trash2, X } from "lucide-react";
import { api, formatNum } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { saveBlob, AY_ADLARI } from "./bankUtils";

export const MealHistoryModal = ({ onClose }) => {
  const { isAdmin } = useAuth();
  const [rows, setRows] = useState(null);
  const load = () => api.get("/payroll/meal-history").then((r) => setRows(r.data.rows)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);

  const redownload = async (h) => {
    try {
      const r = await api.get(`/payroll/meal-history/${h.id}/download`, { responseType: "blob" });
      saveBlob(r, h.filename);
      toast.success("Dosya aynen yeniden indirildi");
    } catch { toast.error("İndirilemedi"); }
  };
  const remove = async (h) => {
    if (!window.confirm(`${AY_ADLARI[h.ay - 1]} ${h.yil} yemek listesi geçmişten silinsin mi?`)) return;
    try { await api.delete(`/payroll/meal-history/${h.id}`); toast.success("Silindi"); load(); } catch { toast.error("Silinemedi"); }
  };

  return (
    <div className="fixed inset-0 z-[70] bg-black/50 flex items-center justify-center p-4" data-testid="meal-history-modal">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[85vh] flex flex-col">
        <div className="p-3 border-b flex items-center justify-between">
          <div>
            <div className="text-sm font-bold text-slate-900">Yemek Listesi Geçmişi</div>
            <div className="text-[11px] text-slate-500">İndirilen her Pluxee dosyası o anki hâliyle saklanır; yeniden indirince birebir aynısı gelir.</div>
          </div>
          <button onClick={onClose} data-testid="meal-history-close" className="w-7 h-7 rounded-lg hover:bg-slate-100 grid place-items-center"><X size={14} /></button>
        </div>
        <div className="p-3 overflow-y-auto">
          <table className="w-full text-xs">
            <thead className="bg-slate-50">
              <tr><th className="text-left px-2 py-1.5">Oluşturma</th><th className="text-left px-2 py-1.5">Dönem</th>
                <th className="text-right px-2 py-1.5">Kart</th><th className="text-right px-2 py-1.5">Toplam</th>
                <th className="text-left px-2 py-1.5">Oluşturan</th><th></th></tr>
            </thead>
            <tbody>
              {rows && rows.length === 0 && <tr><td colSpan={6} className="text-center text-slate-400 py-6">Henüz yemek listesi indirilmemiş</td></tr>}
              {(rows || []).map((h) => (
                <tr key={h.id} className="border-b border-slate-100" data-testid={`meal-history-row-${h.id}`}>
                  <td className="px-2 py-1.5 font-mono text-[11px]">{new Date(h.created_at).toLocaleString("tr-TR")}</td>
                  <td className="px-2 py-1.5 font-semibold">{AY_ADLARI[h.ay - 1]} {h.yil}</td>
                  <td className="px-2 py-1.5 text-right">{h.count}{h.no_card_count ? <span className="text-rose-600" title={(h.no_card || []).map((x) => x.ad_soyad).join(", ")}> (+{h.no_card_count} kartsız)</span> : null}</td>
                  <td className="px-2 py-1.5 text-right font-mono-tab font-semibold">{formatNum(h.total)}</td>
                  <td className="px-2 py-1.5 text-slate-600">{h.created_by_name}</td>
                  <td className="px-2 py-1.5 text-right whitespace-nowrap">
                    <button onClick={() => redownload(h)} data-testid={`meal-history-download-${h.id}`} title="Yeniden indir" className="p-1.5 bg-teal-100 hover:bg-teal-200 text-teal-800 rounded"><Download size={13} /></button>
                    {isAdmin && <button onClick={() => remove(h)} data-testid={`meal-history-delete-${h.id}`} title="Sil" className="ml-1 p-1.5 bg-rose-100 hover:bg-rose-200 text-rose-700 rounded"><Trash2 size={13} /></button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
